import { getContentFullUrl } from "@/lib/contentUtils";
import { convertPlayerAllTimesToPlayerTimezone } from "./DSDateUtils";
import { eliminateExpired } from "./DSExpirationChecker";
import { generatePlaylist } from "./DSPlaylistGenerator";
import { getTheHighestPriorityItemOrShuffled } from "./DSPriotization";
import { deepCloneWithDates } from "./DSSerialization";
import { DSContent, DSContentGroup, DSPlayerOBj, PlayerComputedContentOrContentGroup } from "./types";

const prefetchContent = (content: DSContent<any>) => {
  if (content && navigator.onLine) {
    const fullUrl = getContentFullUrl(content?.contentStorageName || "");
    const img = new Image();
    img.src = fullUrl;
    img.onload = () => {
      console.log("prefetchContent loaded", fullUrl);
    };
    img.onerror = () => {
      console.log("prefetchContent error", fullUrl);
    };
  }
};

const prefetchContentGroup = (contentGroup: DSContentGroup<any>) => {
  contentGroup.contentDetials.forEach(prefetchContent);
  return contentGroup;
};

const prefetchContents = (dsProcessData: DSPlayerOBj<string>) => {
  const np: DSPlayerOBj<string> = JSON.parse(JSON.stringify(dsProcessData));

  if (np.playerContent) prefetchContent(np.playerContent);
  if (np.playerDefaultContent) prefetchContent(np.playerDefaultContent);
  if (np.playerContentGroup) prefetchContentGroup(np.playerContentGroup);
  if (np.areaDefaultContent) prefetchContent(np.areaDefaultContent);

  for (const area of np.areaContentList || []) {
    if (area.contentGroup) prefetchContentGroup(area.contentGroup);
    if (area.content) prefetchContent(area.content);
  }

  for (const campaign of np.playerCampaigns || []) {
    if (campaign.defaultContent) prefetchContent(campaign.defaultContent);
    for (const detail of campaign.details || []) {
      detail.detailContents.forEach((content) => {
        if (content.contentGroup) prefetchContentGroup(content.contentGroup);
        if (content.content) prefetchContent(content.content);
      });
    }
  }

  if (np.playerChannel) {
    if (np.playerChannel.defaultContent) prefetchContent(np.playerChannel.defaultContent);

    for (const detail of np.playerChannel.details || []) {
      detail.detailContents.forEach((content) => {
        if (content.contentGroup) prefetchContentGroup(content.contentGroup);
        if (content.content) prefetchContent(content.content);
      });
    }
  }
};

export const computeActiveContentOrContentGroup = (dsProcessData: DSPlayerOBj<string>) => {
  prefetchContents(dsProcessData);
  const withTimezone = convertPlayerAllTimesToPlayerTimezone(dsProcessData);
  console.log("[DS] withTimezone", withTimezone);
  const withExpiredEliminated = eliminateExpired(deepCloneWithDates(withTimezone));
  console.log("[DS] withExpiredEliminated", withExpiredEliminated);
  const withPriority = getTheHighestPriorityItemOrShuffled(deepCloneWithDates(withExpiredEliminated));
  console.log("[DS] withPriority", withPriority);

  withPriority.contentOrContentGroup = withPriority.contentOrContentGroup || [];
  const newContentOrContentGroup = withPriority.contentOrContentGroup.filter(
    Boolean
  ) as PlayerComputedContentOrContentGroup[];

  console.log("[DS] withPriority2", withPriority);

  return {
    activeContentOrContentGroup: newContentOrContentGroup,
    fallBackContent: withPriority.fallBackContent,
    source: withPriority.source,
  };
};

export const computePlaylistFromProcessData = (dsProcessData: DSPlayerOBj<string>) => {
  const { activeContentOrContentGroup, fallBackContent } = computeActiveContentOrContentGroup(dsProcessData);

  const dim = {
    width: dsProcessData.playerScreenSizeWidth,
    height: dsProcessData.playerScreenSizeHeight,
  };

  const playlist = activeContentOrContentGroup
    ? generatePlaylist(activeContentOrContentGroup, fallBackContent, dim)
    : [];
  return playlist;
};
